export const BRAVE_FILE_ACCESS_SETTING_URL = "brave://flags/#file-system-access-api";

export type BrowserCapabilityRecoveryResult = "copied" | "manual";
export type UnsupportedBrowserKind = "brave" | "other";

export interface BrowserDetectionEnvironment {
  readonly brave?: {
    isBrave(): Promise<boolean>;
  };
}

export interface BrowserCapabilityRecoveryEnvironment {
  readonly copyText: (text: string) => Promise<void>;
  readonly open: (url: string) => void;
}

const browserEnvironment: BrowserCapabilityRecoveryEnvironment = {
  copyText: async (text) => {
    if (navigator.clipboard?.writeText === undefined) {
      throw new Error("The browser clipboard is unavailable.");
    }
    await navigator.clipboard.writeText(text);
  },
  open: (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  },
};

/** Identifies Brave through its public browser marker and falls back safely on other browsers. */
export async function detectUnsupportedBrowser(
  browserNavigator: BrowserDetectionEnvironment = navigator,
): Promise<UnsupportedBrowserKind> {
  try {
    return (await browserNavigator.brave?.isBrave()) === true ? "brave" : "other";
  } catch {
    return "other";
  }
}

/** Opens Brave's capability flag and preserves a pasteable fallback when internal URLs are blocked. */
export async function openBraveFileAccessSetting(
  environment: BrowserCapabilityRecoveryEnvironment = browserEnvironment,
): Promise<BrowserCapabilityRecoveryResult> {
  try {
    environment.open(BRAVE_FILE_ACCESS_SETTING_URL);
  } catch {
    // Chromium-derived browsers may prevent web pages from opening internal settings URLs.
  }

  try {
    await environment.copyText(BRAVE_FILE_ACCESS_SETTING_URL);
    return "copied";
  } catch {
    return "manual";
  }
}
